import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getRulers = (state: RootState) => state.pages.editor.rulers;

const getAllRulers = createSelector([getRulers], (rulers) => rulers);

export default getAllRulers;
